<script>
    import { defaultCalendarEventColor } from "../../../Utils/utilConstants.svelte";
    import {
        getTitle,
        isObjectEmpty,
    } from "../../../Utils/utilFunctions.svelte";

    import { getTooltipPatientName } from "../helpers/dailyCalendarHelper.svelte";

    export let tooltipData = {};
    export let showTooltip = false;
    export let tooltipPosition = {};

    $: calendarColor = tooltipData?.eventColour ?? defaultCalendarEventColor;

    const displayDataFormat = [
        {
            title: "Time",
            formatData: ({ start, end }) => `${start} - ${end}`,
        },
        {
            title: "Patient",
            formatData: ({ patient }) => `${getTooltipPatientName(patient)}`,
        },
        {
            title: "Hospital",
            formatData: ({ hospital }) => `${hospital ? hospital.name : ""}`,
        },
        {
            title: "Surgeon",
            formatData: ({ surgeon }) =>
            surgeon
                ? `${getTitle(surgeon?.title)} ${surgeon.firstName} ${
                    surgeon.lastName
                    }`
                : "",
        },
        {
            title: "Description",
            formatData: ({ procedureName }) => `${procedureName ?? ""}`,
        },
    ];
</script>

{#if !isObjectEmpty(tooltipData)}
    <div
        class="encounterTooltip {showTooltip ? 'visible' : 'hidden'}"
        style="
                top: {tooltipPosition.top
            ? tooltipPosition.top + 'px'
            : 'auto'};
                left: {tooltipPosition.left
            ? tooltipPosition.left + 'px'
            : 'auto'};
                bottom: {tooltipPosition.bottom
            ? tooltipPosition.bottom + 'px'
            : 'auto'};
                right: {tooltipPosition.right
            ? tooltipPosition.right + 'px'
            : 'auto'};
                background: linear-gradient(to right, {calendarColor} 10px, #ffffff 10px);
                border: 1px solid {calendarColor};
            "
    >
        <div class="flex flex-col flex-1 gap-y-1">
            {#each displayDataFormat as data}
                <div class="flex flex-1 gap-x-2">
                    <strong class="w-24">{data.title}: </strong>
                    <p>{data.formatData(tooltipData)}</p>
                </div>
            {/each}
        </div>
    </div>
{/if}

<style>
    .encounterTooltip {
        position: fixed;
        padding: 8px 8px 8px 16px;
        border-radius: 4px;
        z-index: 1000;
        max-width: 500px;
        font-size: 16px;
        opacity: 0;
    }

    .encounterTooltip.visible {
        opacity: 1;
    }

    .encounterTooltip.hidden {
        display: none;
    }
</style>
